export default __webpack_public_path__ + "static/media/23022024-SMBD.44226d8f.webp";